import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export type EtatEnregistrement = 'none' | 'pending' | 'approved' | 'rejected'

export interface TrustCenterState {
  us: {
    status: EtatEnregistrement
    brand: EtatEnregistrement
    campaign: EtatEnregistrement
    shaken: EtatEnregistrement
    reason: string
    submitted_at: string | null
    details: Record<string, unknown> | null
    setup_fee_cents: number
    /** Frais déjà payés : un nouveau dépôt après un refus est gratuit. */
    paid?: boolean
    monthly_fee_cents: number
    currency: string
  }
  local_numbers: Array<{ id: number; phone_number: string; label: string | null }>
  tollfree_numbers: Array<{ id: number; phone_number: string; label: string | null; status: EtatEnregistrement | 'unknown'; reason: string; checked_at: string | null }>
  prefill: Partial<UsRegistrationForm>
  options: { business_types: string[]; titles: string[]; industries: string[]; use_cases: string[] }
  mock: boolean
}

export interface UsRegistrationForm {
  business_name: string
  business_type: string
  business_number: string
  industry: string
  website: string
  business_email: string
  address1: string
  city: string
  province: string
  postal: string
  country: string
  rep_first_name: string
  rep_last_name: string
  rep_email: string
  rep_phone: string
  rep_title: string
  use_case: string
  description: string
  sample1: string
  sample2: string
  consent: string
  has_links: boolean
  has_phone: boolean
  numbers: number[]
}

export function useTrustCenter(companyId: number | undefined) {
  return useQuery({
    queryKey: ['trust-center', companyId],
    queryFn: async () => {
      const { data } = await api.get<TrustCenterState>(`/api/companies/${companyId}/trust-center/`)
      return data
    },
    enabled: !!companyId,
    staleTime: 60_000,
  })
}

export function useSubmitUsRegistration(companyId: number | undefined) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (form: UsRegistrationForm) => {
      const { data } = await api.post<{ status: EtatEnregistrement }>(`/api/companies/${companyId}/trust-center/`, form)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trust-center', companyId] })
    },
  })
}
